import { render, staticRenderFns } from "./MessageHistoriesTab.vue?vue&type=template&id=357aa18f&scoped=true&lang=pug"
import script from "./MessageHistoriesTab.vue?vue&type=script&lang=ts"
export * from "./MessageHistoriesTab.vue?vue&type=script&lang=ts"
import style0 from "./MessageHistoriesTab.vue?vue&type=style&index=0&id=357aa18f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357aa18f",
  null
  
)

export default component.exports